<ng-container *ngIf="config?.SHOW_SIGN_UP_PASSCODE_FLOW else old">
	<app-web-login-v2></app-web-login-v2>
</ng-container>
<ng-template #old>
	<div class="login-background">
		<div class="vertically-centralized">
			<div class="login-container-wrapper">
				<div class="login-container-wrapper-content">
					<div class="visible-xs" style="margin: 0 auto;max-width: 399px">
						<div class="m-t-81">
							<p></p>
						</div>
						<div class="text-left">
							<svg fill="none" height="48" viewBox="0 0 48 48" width="48"
								xmlns="http://www.w3.org/2000/svg">
								<path clip-rule="evenodd"
									d="M23.832 48H24.0034C35.0907 48 42.5204 45.6774 44.0635 44.215C45.6923 42.7527 47.8354 35.1541 47.8354 24C47.8354 12.8459 45.6923 5.24729 44.0635 3.78492C42.5204 2.35123 35.0907 0.0286509 24.0034 -2.28882e-05H23.832C12.7733 0.0286509 5.31505 2.35123 3.77197 3.78492C2.14316 5.24729 0 12.8459 0 24C0 35.1828 2.14316 42.7527 3.77197 44.215C5.31505 45.6487 12.7447 47.9713 23.832 48ZM34.0329 14.2223L34.9473 25.4337L35.576 33.8065H32.2041C30.7753 33.8065 30.1752 33.1757 30.0609 31.6273L29.5751 21.276H29.518C29.1179 22.7957 25.9746 30.3943 25.9746 30.3943H21.8312C21.8312 30.3943 18.6879 22.681 18.4593 21.8782L18.2878 21.276H18.2307C18.3164 22.595 17.7449 31.6273 17.7449 31.6273C17.6306 33.1757 17.0591 33.8065 15.6017 33.8065H12.2298L13.0014 23.9427L13.9158 14.2223H19.4594L23.8886 24.0287H23.9458C24.3173 22.8531 28.5179 14.2223 28.5179 14.2223H34.0329Z"
									fill="white" fill-rule="evenodd" />
							</svg>
						</div>
						<div class="mobile-login-text">
							Login to Moniepoint
						</div>
					</div>
					<div class="login-container">
						<div class="hidden-xs flex justify-center">
							<svg fill="none" height="50" viewBox="0 0 50 50" width="50"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_4511_216765)">
									<rect fill="white" height="48.327" transform="translate(0.662109 0.836426)"
										width="48.6747" />
									<g clip-path="url(#clip1_4511_216765)">
										<rect fill="white" height="25.3843" width="26.3422" x="12.0332" y="12.4084" />
										<path clip-rule="evenodd"
											d="M24.8291 49.1634H25.003C36.2461 49.1634 43.7802 46.825 45.3449 45.3527C46.9966 43.8804 49.1699 36.23 49.1699 24.9999C49.1699 13.7698 46.9966 6.11949 45.3449 4.64716C43.7802 3.2037 36.2461 0.865295 25.003 0.836426H24.8291C13.6149 0.865295 6.05187 3.2037 4.4871 4.64716C2.8354 6.11949 0.662109 13.7698 0.662109 24.9999C0.662109 36.2589 2.8354 43.8804 4.4871 45.3527C6.05187 46.7962 13.5859 49.1346 24.8291 49.1634ZM35.1739 15.1554L36.1011 26.4433L36.7386 34.8731H33.3193C31.8705 34.8731 31.2619 34.238 31.146 32.679L30.6534 22.2573H30.5955C30.1898 23.7873 27.0023 31.4377 27.0023 31.4377H22.8006C22.8006 31.4377 19.6131 23.6718 19.3813 22.8635L19.2074 22.2573H19.1495C19.2364 23.5852 18.6569 32.679 18.6569 32.679C18.541 34.238 17.9614 34.8731 16.4836 34.8731H13.0643L13.8467 24.9421L14.7739 15.1554H20.3955L24.887 25.0287H24.9449C25.3216 23.8451 29.5813 15.1554 29.5813 15.1554H35.1739Z"
											fill="#0361F0" fill-rule="evenodd" />
									</g>
								</g>
								<defs>
									<clipPath id="clip0_4511_216765">
										<rect fill="white" height="48.327" transform="translate(0.662109 0.836426)"
											width="48.6747" />
									</clipPath>
									<clipPath id="clip1_4511_216765">
										<rect fill="white" height="48.327" transform="translate(0.662109 0.836426)"
											width="48.6747" />
									</clipPath>
								</defs>
							</svg>
						</div>
						<div class="login-note m-t-16 hidden-xs">
							Login to Moniepoint
						</div>
						<div class="login-credentials">
							<form (ngSubmit)="submitForm()" [formGroup]="validateForm" class="login-form" nz-form>
								<nz-form-item>
									<nz-form-control>
										<nz-input-group [nzPrefix]="userPrefixTemplate">
											<input formControlName="username" nz-input placeholder="Username"
												type="text" />
										</nz-input-group>
										<ng-template #userPrefixTemplate>
											<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M14.9478 4.30902C14.1993 3.46487 13.1539 3 12.0001 3C10.8401 3 9.79121 3.46205 9.0462 4.30098C8.29312 5.14915 7.92619 6.30188 8.01235 7.54661C8.18312 10.0023 9.97198 12 12.0001 12C14.0282 12 15.814 10.0027 15.9874 7.54741C16.0747 6.31393 15.7055 5.16362 14.9478 4.30902Z"
													fill="#9BA6B9" />
												<path
													d="M18.769 20.9999H5.23096C5.05375 21.0024 4.87827 20.9621 4.71726 20.8818C4.55626 20.8016 4.41379 20.6835 4.30021 20.5361C4.05022 20.2124 3.94945 19.7703 4.02407 19.3232C4.34867 17.3724 5.36172 15.7337 6.95399 14.5833C8.36856 13.5621 10.1604 13 12 13C13.8396 13 15.6314 13.5625 17.046 14.5833C18.6383 15.7333 19.6513 17.372 19.9759 19.3228C20.0505 19.7699 19.9498 20.212 19.6998 20.5357C19.5863 20.6832 19.4438 20.8014 19.2828 20.8816C19.1218 20.9619 18.9463 21.0023 18.769 20.9999V20.9999Z"
													fill="#9BA6B9" />
											</svg>
										</ng-template>
									</nz-form-control>
								</nz-form-item>
								<nz-form-item>
									<nz-form-control>

										<nz-input-group [nzPrefix]="passwordPrefixTemplate" [nzSuffix]="suffixTemplate">
											<input [type]="passwordVisible ? 'text' : 'password'" autocomplete="off"
												formControlName="password" nz-input placeholder="Password" />
										</nz-input-group>
										<ng-template #suffixTemplate>
											<ng-container>
												<svg (click)="passwordVisible = !passwordVisible" class="cursor-pointer"
													fill="none" height="24" viewBox="0 0 24 24" width="24"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
														fill="#9BA6B9" />
													<path
														d="M23.0081 11.1844C21.7678 9.26625 20.1586 7.63688 18.3548 6.47203C16.3593 5.18203 14.1562 4.5 11.984 4.5C9.9909 4.5 8.03105 5.06953 6.15886 6.19266C4.24965 7.33781 2.51996 9.01078 1.01761 11.1647C0.848014 11.4081 0.754608 11.6965 0.749266 11.9931C0.743924 12.2897 0.826888 12.5813 0.987615 12.8306C2.22558 14.768 3.81886 16.3997 5.59449 17.5486C7.59371 18.8438 9.74527 19.5 11.984 19.5C14.1736 19.5 16.3814 18.8236 18.3684 17.5444C20.1712 16.3833 21.7771 14.7478 23.0128 12.8137C23.168 12.5702 23.25 12.2872 23.2492 11.9984C23.2483 11.7096 23.1647 11.4271 23.0081 11.1844ZM12 16.5C11.1099 16.5 10.2399 16.2361 9.49989 15.7416C8.75987 15.2471 8.18309 14.5443 7.8425 13.7221C7.50191 12.8998 7.41279 11.995 7.58642 11.1221C7.76006 10.2492 8.18864 9.44736 8.81798 8.81802C9.44731 8.18868 10.2491 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.722 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49993C16.236 10.24 16.5 11.11 16.5 12C16.4986 13.1931 16.024 14.3369 15.1804 15.1805C14.3368 16.0241 13.193 16.4986 12 16.5Z"
														fill="#9BA6B9" />
												</svg>
											</ng-container>
										</ng-template>
										<ng-template #passwordPrefixTemplate>
											<svg fill="none" height="20" style="margin-right: 5px" viewBox="0 0 18 20"
												width="18" xmlns="http://www.w3.org/2000/svg">
												<path clip-rule="evenodd"
													d="M3.0001 8.79844V6.39844C3.0001 3.08473 5.68639 0.398438 9.0001 0.398438C12.3138 0.398438 15.0001 3.08473 15.0001 6.39844V8.79844C16.3256 8.79844 17.4001 9.87295 17.4001 11.1984V17.1984C17.4001 18.5239 16.3256 19.5984 15.0001 19.5984H3.0001C1.67461 19.5984 0.600098 18.5239 0.600098 17.1984V11.1984C0.600098 9.87295 1.67461 8.79844 3.0001 8.79844ZM12.6001 6.39844V8.79844H5.4001V6.39844C5.4001 4.41021 7.01187 2.79844 9.0001 2.79844C10.9883 2.79844 12.6001 4.41021 12.6001 6.39844Z"
													fill="#9BA6B9" fill-rule="evenodd" />
											</svg>
										</ng-template>

									</nz-form-control>
								</nz-form-item>
								<div class="help">
									<span [routerLink]="'/forgot-username'" class="addCursor">
										Forgot Username
									</span>
									<span style="color:#000000"> or </span>
									<span [routerLink]="'/password-reset'" class="addCursor">
										Password?
									</span>
								</div>

								<div class="login-btn-margin">
									<div>
										<app-kamona-custom-button [isBlock]="true" [isSubmitting]="submitting"
											[state]="'primary'" text="Login">
										</app-kamona-custom-button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div class="login-container-wrapper-footer">
					<div *ngIf="config.ALLOW_SIGN_UP" class="new-moniepoint-user-wrapper flex justify-center">
						<div nz-row nzAlign="middle" style="text-align: center">
							<div>New to Moniepoint?</div>
							<div (click)="signUp()" class="addCursor link"> Sign Up
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="webBicon" class="relative">
			<img referrerpolicy="no-referrer-when-downgrade" src="https://d21y75miwcfqoq.cloudfront.net/88d52769"
				style="position: absolute">
		</div>
	</div>
</ng-template>